<template>
  <div class="flex flex-col h-full">
    <div class="p-16 border-b border-grey-divider-subdued">
      <h2 class="text-h4">Messages</h2>
    </div>
    <div class="flex-1 overflow-y-auto">
      <div v-if="loading">
        <ChannelListSkeleton />
      </div>
      <div v-else-if="channels.length === 0">
        <EmptyStateCard
          class="ml-16"
          :title="emptyTitle"
          :message="emptyMessage"
          :action-text="emptyActionText"
          :action-url="emptyActionUrl"
          :action-to="emptyActionTo"
          @action="$emit('emptyAction')"
        />
      </div>
      <div v-else id="channel-list" class="flex flex-col">
        <ChannelListItem
          v-for="channel in channels"
          :key="channel.url"
          :channel-url="channel.url"
          :name="channel.name"
          :avatar-url="channel.avatarUrl"
          :last-message="channel.lastMessage"
          :last-message-at="channel.lastMessageAt"
          :unread-count="channel.unreadCount"
          :is-active="channel.url === selectedChannelUrl"
          @select="$emit('select', $event)"
          @prefetch="$emit('prefetch', channel.url)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import EmptyStateCard from '@/components/empty_state_card/EmptyStateCard.vue';
import ChannelListItem from '@/apps/messages/components/channelList/ChannelListItem.vue';
import ChannelListSkeleton from '@/apps/messages/components/channelList/ChannelListSkeleton.vue';

interface ChannelListItemData {
  url: string;
  name: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastMessageAt?: string;
  unreadCount?: number;
}

export default {
  name: 'ChannelList',
  components: {
    EmptyStateCard,
    ChannelListItem,
    ChannelListSkeleton,
  },
  props: {
    channels: {
      type: Array as PropType<ChannelListItemData[]>,
      default: () => [],
    },
    selectedChannelUrl: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyTitle: {
      type: String,
      default: 'No messages',
    },
    emptyMessage: {
      type: String,
      default: 'Your conversations with sitters will appear here',
    },
    emptyActionText: {
      type: String,
      default: '',
    },
    emptyActionUrl: {
      type: String,
      default: '',
    },
    emptyActionTo: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: null,
    },
  },
  watch: {
    channels() {
      // Scroll to the top of #channel-list when channels are updated (e.g. new message received)
      const channelListElement = document.getElementById('channel-list');
      if (channelListElement) {
        channelListElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
};
</script>
